import {LEARNCREATOR_START_PATH} from './constants';

/**
 * Open LearnCreator the way the workspace menu does — its landing page
 * (`/dq_pro/learncreator/start`) — but in a new tab, so the page the user is
 * reading (e.g. a dashboard's Recommended Learning Programs) stays put
 * (QA 9 Oct 2026, LA-SD-5).
 *
 * `window.open` is called without the `noopener` feature on purpose: with it
 * browsers return null even when the tab opens, which would make the
 * pop-up-blocked fallback fire every time and navigate this tab too. The
 * opener link is cut by hand instead. Only when the browser really blocked the
 * pop-up (null) does the current tab navigate there itself.
 *
 * @param {object} history react-router history, used only for the fallback
 * @returns {boolean} true when a new tab was opened
 */
export const openLearnCreator = (history) => {
    const url = `${window.location.origin}${LEARNCREATOR_START_PATH}`;
    let win = null;
    try { win = window.open(url, '_blank'); } catch (e) { win = null; }
    if (win) {
        try { win.opener = null; } catch (e) { /* cross-origin guard: nothing to cut */ }
        return true;
    }
    if (history && typeof history.push === 'function') history.push(LEARNCREATOR_START_PATH);
    return false;
};

export default openLearnCreator;
